import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import FullUser from "../fragments/fullUserV4"

const query = gql`
  query GetUserByEmail($email: String!, $tenantId: String!) {
    getUserByEmail(email: $email, tenantId: $tenantId) {
      ...fullUser
    }
  }
  ${FullUser}
`

export const getUserByEmailKey = getQueryNames(query)[0]

export default query
